/*
 * Reads the Gagl API's product feature flags (GET /flags) once per page load.
 *
 * The endpoint requires a signed-in user. Guests have no Gagl API token, and
 * this app's axios setup reloads the page on any 401, so the request is made
 * only when a token is present; otherwise every flag reads as off. Any failure
 * also reads as off, which is today's behavior.
 *
 * Developed by Bill Dunning using an AI coding partner through interactive interrogation and direction. No code enters this file until it has been read, understood, and approved by the author; AI output is never committed unreviewed.
 */
const { jitsiLocalStorage } = require('lib-js-utils/jitsi-local-storage');

let flagsPromise = null;

export default class FlagsService {
    constructor(axios) {
        this.axios = axios;
    }

    getFlags() {
        if (!jitsiLocalStorage.getItem('auth_token')) {
            return Promise.resolve({});
        }
        if (!flagsPromise) {
            flagsPromise = this.axios.get('/flags')
                .then(res => (res && res.data && res.data.flags) || {})
                .catch(() => {
                    flagsPromise = null;

                    return {};
                });
        }

        return flagsPromise;
    }

    isOn(name) {
        return this.getFlags().then(flags => flags[name] === true);
    }
}
